// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";


const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useAuth();

  // If no logged in user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user's role is not in allowedRoles, redirect to a not-authorized page or another route
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/not-authorized" replace />;
  }

  // Otherwise, render the nested route elements
  return <Outlet />;
};

export default ProtectedRoute;